import { AnyObject } from "global";
import { IStorage } from "./storage.d";

const StorageObject: AnyObject = {};
const storageBackup: IStorage = {
  getItem: (key: string) => {
    return StorageObject[key] || null;
  },
  setItem: (key, value) => {
    StorageObject[key] = value;
  },
  removeItem: key => {
    delete StorageObject[key];
  }
};

function getDefaultStorage() {
  try {
    return window.localStorage;
  } catch (error) {
    return storageBackup;
  }
}

export default abstract class Storage<T extends string> {
  private readonly storage: IStorage;

  public constructor(getStorage = getDefaultStorage) {
    this.storage = getStorage();
  }

  protected get(key: T): string | null {
    return this.storage.getItem(key);
  }

  protected set(key: T, value: string): void {
    this.storage.setItem(key, value);
  }

  protected clearItem(key: T): void {
    this.storage.removeItem(key);
  }

  protected clearItems(keys: T[]): void {
    keys.forEach(key => this.clearItem(key));
  }
}
